// UID: BWR-FIN_STMT_3Y-FILE
// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2247

import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import { RulesetResult, IsForProfit, HasApplicantNotFiledTR } from '../rules';
import IsFBO from '../rules/IsFBO';
import IsBusinessEstablishedMoreThan from '../rules/IsBusinessEstablishedMoreThan';

class FinancialStatementThreeYearsAgoFullYearRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const establishedMoreThanThreeYearsAgo =
      IsBusinessEstablishedMoreThan.setYears(3).evaluate(data);

    if (IsFBO.evaluate(data)) {
      return establishedMoreThanThreeYearsAgo
        ? RulesetResult.REQUIRED
        : RulesetResult.HIDDEN;
    }

    const isNonProfit = !IsForProfit.evaluate(data);
    const hasApplicantNotEverFiledTR = HasApplicantNotFiledTR.evaluate(data);

    if (
      isNonProfit &&
      establishedMoreThanThreeYearsAgo &&
      hasApplicantNotEverFiledTR
    )
      return RulesetResult.REQUIRED;

    return RulesetResult.HIDDEN;
  };
}

export default new FinancialStatementThreeYearsAgoFullYearRuleset();
